import React from 'react'
import TagsAutocomplete from "../../../CommonComponent/TagsAutocomplete";
import './share.scss'
import { Iprops } from './shareinterface';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../../const/resource";
import Alerts from '../../../Alerts';
import Loader from '../../../Loader';

const Share = (props: Iprops) => {
  const { t } = useTranslation();

  const renderSuggestion = ({ text, ...suggestionProps }: any) => {
    return (
      <>
        {suggestionProps?.id != "" ?
          <div {...suggestionProps}>
            <strong>{text}</strong>
          </div> :
          <div {...suggestionProps} className="dropdownNoteBackground">
            <span className="updatedNote"><span className="noteBold">{t(RESOURCE.MyK_Label_SC_Note)}: </span>{text}</span>
          </div>
        }
      </>
    )
  };

  return (
    <div className='sharepartlist_wrapper'>
      {props?.showShareAlert && (
        <div className="col-12 mb-2 mt-2">
          <Alerts
            messageAlert={props?.errorShareMsg}
            alertType={'error'}
            onClose={props?.handleAlertClose}
          />
        </div>
      )}
      <div className='mb-1'>
        <span className='useremail_heading'> {t(RESOURCE.MyK_Label_SC_Quote_User_Email)} </span> <sup>*</sup>
      </div>
      <div className='useremail_inputfield'>
        <TagsAutocomplete
          tags={props?.tags}
          suggestions={props?.suggestions?.data}
          onChangeEvent={props?.onEmailText}
          onInputChange={props?.onEmailInputChange}
          handleAddition={props?.handleAddTag}
          handleDelete={props?.handleDeleteTag}
          renderSuggestion={renderSuggestion}
          handleInputBlur={props?.handleInputBlur}
          placeholder={t(RESOURCE.MyK_Label_ShoppingCart_Email_PlaceHolder)}
        />
        {props?.suggestions?.loading &&
          <Loader />
        }
      </div>
      <div className='footerbuttons mt-3'>
        <button className='cancelbtn mr-1' title={t(RESOURCE.MyK_Label_Cancel)} onClick={props.openSharePopup}>{t(RESOURCE.MyK_Label_Cancel)}</button>
        <button className='savebtn' onClick={() => props?.onClickSend()} title={t(RESOURCE.MyK_Label_SC_Quote_Send)}>{t(RESOURCE.MyK_Label_SC_Quote_Send)}</button>
      </div>
    </div>
  )
}

export default Share